const $ = require('jquery');
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import run from '../../utilities/run';
import { isPresent, isBlank } from '../../utilities/general'
import render from "../../utilities/render";
import ReviewTab from './reviewTab.js';
import ConnectionTab from './connectionTab.js';
import ConfigurationTab from './configurationTab.js';

require("./createChannelWizard.less");

const wizardTargetSelector = "#p_p_id_channels_WAR_hcportlet_";
// Live form from jsp
run("#create-channel-form", () => {
  const el = $("#create-channel-form");
  attachWizard(el);
  setupEditChecker();
});

function setupEditChecker() {
  EditChecker.bindNavigation();
  EditChecker.bindChangeListener("#create-channel-form");
  EditChecker.bindCancelButton("#create-channel-cancel-btn");
}

function attachWizard(el) {
  const wizardElement = el;
  const amazonCmrDomainConfigData = wizardElement.data("amazon-connection-setup");
  const realTimeApiRetailerPartnerData = wizardElement.data("retailer-realtime-api-details");
  const amazonParId = wizardElement.data("amazon-par-id");
  const amazonMktPlcParId = el.data("amazon-market-palce-par-id");
  const realTimeApiParId = el.data("realtime-api-par-id");
  const parId = el.data("partner-id");

  const validator = el.validate({
    errorPlacement: function (error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }

  });

  validator.settings.ignore = ":disabled,:hidden";


  const quickWizard = new QuickWizard(el, {
    tabletWidthNavStep: 902,
    mobileWidthNavStep: 502,

    shouldNavigateToForm: ({ targetForm, direction }) => {
      // Any time we go traverse backwards, just let us
      if (direction === "BACKWARDS") {
        return true;
      }
      // handle general validations on forward traversal
      let allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);

      if (!quickWizard.areInputsValid(allPrevInputs, { displayErrors: true })) {
        quickWizard.goToFirstIncompleteForm();
        return false;
      }
    },
    didNavigateToForm: function ({ currentForm }) {
      if (currentForm.filter('.connections-tab').length) {
        connectionTab.didNavigateToForm();
      } else if (currentForm.filter('.configuration-tab').length) {
        configurationTab.didNavigateToForm();
      } else if (currentForm.filter('.review-tab').length) {
        reviewTab.didNavigateToForm();
      }
    }

  });
  quickWizard.init();
  const targetTab = getTargetInitialTab(amazonCmrDomainConfigData);

  if (targetTab) {
    quickWizard.gotToForm(targetTab);
  }

  function getTargetInitialTab(amazonCmrDomainConfigData) {
    if (realTimeApiRetailerPartnerData != "") {
      return $('.connection-tab');
    }
    else {
      return $('.instructions-tab');
    }
  }

  function canSave(quickWizard) {
    const currentForm = quickWizard.getActiveTargetForm();
    let isValid = true;
    if (currentForm.filter(".connection-tab").length) {
      isValid = areInputsValidForForm(currentForm);
    }
    return isValid;
  }

  const connectionTab = new ConnectionTab(quickWizard);
  connectionTab.init();

  let configurationTab = "";
  if (amazonMktPlcParId == parId) {
    configurationTab = new ConfigurationTab(quickWizard);
    configurationTab.init();
  }

  const reviewTab = new ReviewTab(quickWizard);
  reviewTab.init();


}



// WEBPACK FOOTER //
// ./src/pages/createChannel/createChannelWizard.js